import { render, staticRenderFns } from "./RecordList.vue?vue&type=template&id=3f8b8532&scoped=true"
import script from "./RecordList.vue?vue&type=script&lang=ts"
export * from "./RecordList.vue?vue&type=script&lang=ts"
import style0 from "./RecordList.vue?vue&type=style&index=0&id=3f8b8532&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8b8532",
  null
  
)

export default component.exports